import { create } from 'zustand';

import service from '@/services/index';

type State = {
  init: boolean;
  loading: boolean;
  regionMap: RegionMapT;
  languageList: LanguageT[];
};

type Actions = {
  fetchRegionMap: (workspaceAlias: string) => void;
  fetchLanguageList: (workspaceAlias: string) => void;
  initLocaleStore: () => void;
  setState: StoreSetter<State>;
};

const initialState: State = {
  init: false,
  loading: false,
  regionMap: {},
  languageList: [],
};

const useLocaleStore = create<State & Actions>((set, get) => ({
  ...initialState,
  async fetchRegionMap(workspaceAlias: string) {
    const res = await service.util.fetchRegionList(workspaceAlias);
    const map: RegionMapT = res.reduce((acc, value) => {
      acc[value.code] = value;
      return acc;
    }, {} as RegionMapT);
    set({
      regionMap: map,
    });
    return map;
  },
  async fetchLanguageList(workspaceAlias: string) {
    const res = await service.util.fetchLanguageList(workspaceAlias);
    set({
      languageList: res,
    });
    return res;
  },
  initLocaleStore() {
    set(initialState);
  },
  setState: set,
}));

export const useFeedbackRegionList = () => {
  const regionMap = useLocaleStore((state) => state.regionMap);
  return Object.values(regionMap).filter((region) => region.in_feedback);
};

export const useFeedbackLanguageList = () => {
  const languageList = useLocaleStore((state) => state.languageList);
  return languageList.filter((language) => language.in_feedback);
};

export default useLocaleStore;
